import React, {
	useState,
	useEffect,
	useCallback,
	useContext,
	useRef,
} from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Drawer as MenuDrawer } from "@mui/material";
import Drawer from "../../assets/drawer.png";
import Drawer2 from "../../assets/drawer2.png";
import DrawerNoIcon from "../../assets/drawer-no-icon.png";
import Drawer2NoIcon from "../../assets/drawer2-no-icon.png";
import ServiceDrawer from "../../assets/serviceDrawer.png";
import TabBar from "../../assets/tabBar.png";
import TabBar2 from "../../assets/tabBar2.png";
import TabBar3 from "../../assets/tabbar-ios.png";
import TabBar4 from "../../assets/tabbar-ios-no-title.png";
import TabBar5 from "../../assets/tabbar-ios-services.png";
import TabBar6 from "../../assets/tabbar-ios-services-no-title.png";
import ServiceTabBar from "../../assets/serviceTabBar.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { Alert, Checkbox, CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";

import { CreatorContext } from "../../context/CreatorContext";
import EmptyIphone from "../../assets/iphone-empty.png";
import TopBar from "../../assets/top-bar.png";
import ShowcaseTabBar from "../../components/ShowcaseTabBar/ShowcaseTabBar";
import ShowcaseLayout from "../../components/ShowcaseLayout/ShowcaseLayout";
import ShowcaseTopBar from "../../components/ShowcaseTopBar/ShowcaseTopBar";
import { ShowcaseDrawer } from "../../components/ShowcasesDrawer/ShowcasesDrawer";

import LogoBarber from "../../assets/showcases/barber-logo.png";
import LogoSalon from "../../assets/showcases/salon-logo.png";
import LogoTrainer from "../../assets/showcases/trainer-logo.png";
import LogoEcommerce from "../../assets/showcases/ecommerce-logo.png";
import LogoRestaurant from "../../assets/showcases/restaurant-logo.png";
import ShowcaseLayoutEcommerce from "../../components/ShowcaseLayoutEcommerce/ShowcaseLayoutEcommerce";

import Arrow from "../../assets/arrow.png";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	alert: {
		cursor: "pointer",
		"& *": {
			cursor: "pointer",
		},
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	},
});

export default function Navigation({
	drawerWidth,
	setRun,
	goToAppearance,
	setGoToAppearance,
}) {
	const classes = useStyles();
	const [navigationType, setNavigationType] = useState("Tab Bar");
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [drawerHovered, setDrawerHovered] = useState(false);
	const [tabBarHovered, setTabBarHovered] = useState(false);
	const navigate = useNavigate();
	const { user } = useContext(UserContext);
	const alert = useAlert();
	const service = user.app.appType === "Services";
	const { t } = useTranslation();
	const { getCreator, creator } = useContext(CreatorContext);

	const [hideMenuTitle, setHideMenuTitle] = useState(null);
	const [hideMenuIcon, setHideMenuIcon] = useState(null);

	const [isDrawerOpen, setDrawerOpen] = useState(false);

	const iphoneRef = useRef(null);
	const toggleDrawer = () => {
		setDrawerOpen(!isDrawerOpen);
	};

	const getLogo = (sector) => {
		switch (sector) {
			case "barber":
				return LogoBarber;

			case "salon":
				return LogoSalon;

			case "trainer":
				return LogoTrainer;

			case "ecommerce":
				return LogoEcommerce;

			case "restaurant":
				return LogoRestaurant;
			default:
				return {};
		}
	};

	useEffect(() => {
		setRun(true);
		setTimeout(() => {
			setDrawerOpen(true);
		}, 500);
	}, []);

	useEffect(() => {
		if (goToAppearance) {
			setGoToAppearance(false);
			navigate("/colors");
		}
	}, [goToAppearance]);

	const getNavigationData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setData(res.data);
			setNavigationType(res.data.navigationType);
			setHideMenuTitle(res.data.hideMenuTitle);
			setHideMenuIcon(res.data.hideMenuIcon);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const saveNavigationData = useCallback(async () => {
		setLoading(true);
		if (
			data.creatorPages.filter((page) => page.visible).length > 5 &&
			navigationType === "Tab Bar"
		) {
			alert.show(t("navigation.error"), { type: "error" });
		} else {
			try {
				await axios.post(
					ADMIN_URL + "creators",
					{ navigationType, hideMenuTitle, hideMenuIcon },
					{
						headers: { authorization: localStorage.getItem("token") },
					}
				);
				getCreator();
				alert.show(t("general.success"), { type: "success" });
			} catch (error) {
				console.log(error);
			}
		}
		setLoading(false);
	}, [data, hideMenuTitle, navigationType, hideMenuIcon]);

	useEffect(() => {
		getNavigationData();
	}, []);

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("navigation.title")}
						</Typography>
						<div className={classes.cardInfo}>
							<RadioGroup
								aria-labelledby="demo-radio-buttons-group-label"
								defaultValue="Tab Bar"
								name="radio-buttons-group"
								value={navigationType}
								onChange={(e) => {
									setNavigationType(e.target.value);
								}}
							>
								<Grid container className={classes.cardForm}>
									<Grid
										item
										xs={12}
										sm={6}
										container
										direction="column"
										className={classes.cardGrid}
									>
										<FormControlLabel
											value="Tab Bar"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={t("navigation.tabBar")}
										/>
										<div style={{ position: "relative" }}>
											<Box
												sx={{
													position: "absolute",
													bottom: 35,
													left: -20,
													zIndex: 100,

													"& img": {
														width: 100,
														transform: "rotate(40deg)",
														animation: "bounce 6s infinite ease-in-out",
														transformOrigin: "50% 50%",
													},
												}}
											>
												<img src={Arrow} alt="arrow" />
											</Box>
											<Box
												sx={{
													position: "absolute",
													bottom: {
														xs: 100,
														sm: 108,
													},
													left: {
														xs: -25,
														sm: -60,
													},
													zIndex: 100,
													backgroundColor: "#000000",
													padding: "6px",
													borderRadius: "50%",
													aspectRatio: "1",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													textAlign: "center",
													color: "#fff",
												}}
											>
												<Typography
													sx={{
														fontSize: 8,
														fontWeight: 700,
														maxWidth: 60,
														textTransform: "uppercase",
													}}
												>
													{t("navigation.thisIsTabbar")}
												</Typography>
											</Box>
											<div
												className={classes.iphoneContainer}
												style={{ position: "relative" }}
											>
												<img
													src={EmptyIphone}
													alt="iphone"
													onMouseOver={() => {}}
													onMouseLeave={() => {}}
													className={classes.iphone}
												/>

												<img
													src={TopBar}
													alt="iphone"
													onMouseOver={() => {}}
													onMouseLeave={() => {}}
													className={classes.iphone}
													style={{
														position: "absolute",
														top: 0,
														left: 0,
														zIndex: 3,
														WebkitUserDrag: "none",
													}}
												/>

												<Box
													sx={{
														position: "absolute",
														top: 0,
														bottom: 0,
														padding:
															"53.75px 29px 72.25px 30px" /*"55.25px 29px 73px 30.25px",*/,
														width: 260,
														zIndex: 2,
													}}
													draggable={false}
												>
													<Box sx={{ marginTop: "-45px" }}>
														{/* CAMBIAR QUAN TINGUEM EL TIPO DE APP */}
														<ShowcaseTopBar
															logo={
																creator.appLogo
																	? creator.appLogo
																	: getLogo(
																			user?.app?.appSubtype?.toLowerCase() ??
																				"barber"
																	  )
															}
														/>
													</Box>
													<Box
														id="showcase"
														sx={{
															width: "100%",
															aspectRatio: "220 / 386.5",
															borderBottomRightRadius: 0,
															borderBottomLeftRadius: 0,
															overflow: "auto",
															display: "flex",
															flexDirection: "column",
															backgroundColor: creator.themeColor,
															color:
																creator.themeMode === "Dark"
																	? "#ffffff"
																	: "#000000",
														}}
													>
														{user.app.appType === "Ecommerce" ? (
															<ShowcaseLayoutEcommerce
																showBanner={creator.homeShowBanners}
																homeShowSearch={creator.homeShowSearch}
																homeShowStickyHeader={
																	creator.homeShowStickyHeader
																}
																homeShowBigCarrousel={
																	creator.homeShowBigCarrousel
																}
																homeShowBigOverlayCarrousel={
																	creator.homeShowBigOverlayCarrousel
																}
																homeShowBanners={creator.homeShowBanners}
																homeShowPadding={creator.homeShowPadding}
																homeProductType={creator.homeProductType}
																homeProductBackgroundColor={
																	creator.homeProductBackgroundColor
																}
																homeListType={creator.homeListType}
																homeCategory={creator.homeCategory}
																homeShowNews={creator.homeShowNews}
																homeShowFeatured={creator.homeShowFeatured}
																homeNewStyle={creator.homeNewStyle}
																homeFeatureStyle={creator.homeFeatureStyle}
																sector={
																	user?.app?.appSubtype?.toLowerCase() ??
																	"barber"
																}
																searchBackgroundColor={
																	creator.searchBackgroundColor
																}
																showSearchIcon={creator.showSearchIcon}
																searchTextColor={creator.searchTextColor}
																searchContainerBackgroundColor={
																	creator.searchContainerBackgroundColor
																}
																homeShowCategoriesGrid={creator.showCategories}
															/>
														) : (
															<ShowcaseLayout
																showBanner={creator.homeShowBanners}
																homeShowSearch={creator.homeShowSearch}
																homeShowStickyHeader={
																	creator.homeShowStickyHeader
																}
																homeShowBigCarrousel={
																	creator.homeShowBigCarrousel
																}
																homeShowBigOverlayCarrousel={
																	creator.homeShowBigOverlayCarrousel
																}
																homeShowBanners={creator.homeShowBanners}
																homeShowPadding={creator.homeShowPadding}
																homeProductType={creator.homeProductType}
																homeProductBackgroundColor={
																	creator.homeProductBackgroundColor
																}
																homeListType={creator.homeListType}
																homeCategory={creator.homeCategory}
																homeShowNews={creator.homeShowNews}
																homeShowFeatured={creator.homeShowFeatured}
																homeNewStyle={creator.homeNewStyle}
																homeFeatureStyle={creator.homeFeatureStyle}
																sector={
																	user?.app?.appSubtype?.toLowerCase() ??
																	"barber"
																}
															/>
														)}
													</Box>
													<Box
														sx={{
															height: "38px",
														}}
													>
														<ShowcaseTabBar
															hideMenuIcon={hideMenuIcon}
															hideMenuTitle={hideMenuTitle}
														/>
													</Box>
												</Box>
											</div>
										</div>
									</Grid>
									<Grid
										item
										xs={12}
										sm={6}
										container
										direction="column"
										className={classes.cardGrid}
									>
										<FormControlLabel
											value="Drawer"
											control={
												<Radio
													id="drawer"
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={t("navigation.drawer")}
										/>
										<div style={{ position: "relative" }}>
											<Box
												sx={{
													position: "absolute",
													bottom: 150,
													right: 55,
													zIndex: 100,

													"& img": {
														width: 100,
														animation: "bounce2 6s infinite ease-in-out",
														transformOrigin: "50% 50%",
													},
												}}
											>
												<img src={Arrow} alt="arrow" />
											</Box>
											<Box
												sx={{
													position: "absolute",
													bottom: {
														xs: 100,
														sm: 108,
													},
													right: {
														xs: 55,
														sm: 55,
													},
													zIndex: 100,
													backgroundColor: "#000000",
													padding: "6px",
													borderRadius: "50%",
													aspectRatio: "1",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													textAlign: "center",
													color: "#fff",
												}}
											>
												<Typography
													sx={{
														fontSize: 8,
														fontWeight: 700,
														maxWidth: 60,
														textTransform: "uppercase",
													}}
												>
													{t("navigation.thisIsDrawer")}
												</Typography>
											</Box>
											<div
												className={classes.iphoneContainer}
												style={{ position: "relative" }}
											>
												<img
													src={EmptyIphone}
													alt="iphone"
													onMouseOver={() => {}}
													onMouseLeave={() => {}}
													className={classes.iphone}
												/>

												<img
													src={TopBar}
													alt="iphone"
													onMouseOver={() => {}}
													onMouseLeave={() => {}}
													className={classes.iphone}
													style={{
														position: "absolute",
														top: 0,
														left: 0,
														zIndex: 3,
														WebkitUserDrag: "none",
														pointerEvents: "none",
													}}
												/>

												<Box
													sx={{
														position: "absolute",
														top: 0,
														bottom: 0,
														padding:
															"53.75px 29px 72.25px 30px" /*"55.25px 29px 73px 30.25px",*/,
														width: 260,
														zIndex: 2,
													}}
													draggable={false}
													ref={iphoneRef}
												>
													<Box sx={{ marginTop: "-45px" }}>
														{/* CAMBIAR QUAN TINGUEM EL TIPO DE APP */}
														<ShowcaseTopBar
															logo={creator.appLogo}
															showDrawer
															onMenuClick={toggleDrawer}
														/>
													</Box>

													<Box
														id="showcase"
														sx={{
															width: "100%",
															aspectRatio: "220 / 427",
															borderBottomRightRadius: "26px",
															borderBottomLeftRadius: "26px",
															overflow: "auto",
															display: "flex",
															flexDirection: "column",
															position: "relative",
															backgroundColor: creator.themeColor,
															color:
																creator.themeMode === "Dark"
																	? "#ffffff"
																	: "#000000",
														}}
													>
														{user.app.appType === "Ecommerce" ? (
															<ShowcaseLayoutEcommerce
																showBanner={creator.homeShowBanners}
																homeShowSearch={creator.homeShowSearch}
																homeShowStickyHeader={
																	creator.homeShowStickyHeader
																}
																homeShowBigCarrousel={
																	creator.homeShowBigCarrousel
																}
																homeShowBigOverlayCarrousel={
																	creator.homeShowBigOverlayCarrousel
																}
																homeShowBanners={creator.homeShowBanners}
																homeShowPadding={creator.homeShowPadding}
																homeProductType={creator.homeProductType}
																homeProductBackgroundColor={
																	creator.homeProductBackgroundColor
																}
																homeListType={creator.homeListType}
																homeCategory={creator.homeCategory}
																homeShowNews={creator.homeShowNews}
																homeShowFeatured={creator.homeShowFeatured}
																homeNewStyle={creator.homeNewStyle}
																homeFeatureStyle={creator.homeFeatureStyle}
																sector={
																	user?.app?.appSubtype?.toLowerCase() ??
																	"barber"
																}
																searchBackgroundColor={
																	creator.searchBackgroundColor
																}
																showSearchIcon={creator.showSearchIcon}
																searchTextColor={creator.searchTextColor}
																searchContainerBackgroundColor={
																	creator.searchContainerBackgroundColor
																}
																homeShowCategoriesGrid={creator.showCategories}
															/>
														) : (
															<ShowcaseLayout
																showBanner={creator.homeShowBanners}
																homeShowSearch={creator.homeShowSearch}
																homeShowStickyHeader={
																	creator.homeShowStickyHeader
																}
																homeShowBigCarrousel={
																	creator.homeShowBigCarrousel
																}
																homeShowBigOverlayCarrousel={
																	creator.homeShowBigOverlayCarrousel
																}
																homeShowBanners={creator.homeShowBanners}
																homeShowPadding={creator.homeShowPadding}
																homeProductType={creator.homeProductType}
																homeProductBackgroundColor={
																	creator.homeProductBackgroundColor
																}
																homeListType={creator.homeListType}
																homeCategory={creator.homeCategory}
																homeShowNews={creator.homeShowNews}
																homeShowFeatured={creator.homeShowFeatured}
																homeNewStyle={creator.homeNewStyle}
																homeFeatureStyle={creator.homeFeatureStyle}
																sector={
																	user?.app?.appSubtype?.toLowerCase() ??
																	"barber"
																}
															/>
														)}
														<Box
															sx={{
																position:
																	user?.app?.appType === "Ecommerce" ||
																	user?.app?.appType === "Woocommerce"
																		? "relative"
																		: "absolute",
																marginTop: "-53px",
																marginLeft: "-30px",
															}}
														></Box>
													</Box>
												</Box>
												<Box
													sx={{
														position: "absolute",
														top: "8.75px",
														bottom: "36.25px",
														left: "30px",
														right: "29px",
														width: 203,
														zIndex: 2,
														borderRadius: "26px",
														pointerEvents: isDrawerOpen ? "auto" : "none",
														overflow: "hidden",
													}}
													draggable={false}
													ref={iphoneRef}
												>
													<MenuDrawer
														container={iphoneRef.current}
														anchor="left"
														open={isDrawerOpen}
														onClose={toggleDrawer}
														sx={{
															"&.MuiDrawer-root": {
																position: "absolute!important",
															},
															"& > div": {
																position: "absolute!important",
															},
														}}
													>
														<Box
															sx={{
																backgroundColor: creator.navigationColor,
																width: 125,
																height: "100%",
															}}
														>
															<ShowcaseDrawer hideMenuIcon={hideMenuIcon} />
														</Box>
													</MenuDrawer>
												</Box>
											</div>
										</div>
									</Grid>
								</Grid>
							</RadioGroup>
						</div>
						<div style={{ maxWidth: "400px", margin: "auto" }}>
							<Typography
								sx={{
									fontSize: 12,
									marginTop: 2,
									marginBottom: 0,
									fontWeight: 700,
									textTransform: "uppercase",
								}}
								color="text.secondary"
								gutterBottom
							>
								{t("navigation.options")}
							</Typography>
							{navigationType === "Tab Bar" ? (
								<FormControlLabel
									control={
										<Checkbox
											checked={!hideMenuTitle && !hideMenuTitle}
											onChange={(e) => {
												setHideMenuTitle(!hideMenuTitle);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("navigation.hideMenuTitle")}
								/>
							) : (
								<FormControlLabel
									control={
										<Checkbox
											checked={!hideMenuIcon && !hideMenuIcon}
											onChange={(e) => {
												setHideMenuIcon(!hideMenuIcon);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("navigation.hideMenuIcon")}
								/>
							)}
						</div>
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								id="navigation-save"
								variant="contained"
								size="small"
								onClick={saveNavigationData}
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
